// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.posta{
  color: lightcoral;
}

.order-form-page {
  min-height: 100vh;
  background: linear-gradient(to bottom, #f7fafc, #edf2f7);
}

.order-container {
  max-width: 1200px;
  margin: 0 auto;
}

.order-content {
  display: grid;
  grid-template-columns: 1fr 1.5fr;
  gap: 30px;
  margin-top: 30px;
}

.order-summary {
  animation: fadeInLeft 0.6s ease;
}

.order-summary h2,
.order-form-section h2 {
  font-size: 1.8rem;
  font-weight: 800;
  color: #2d3748;
  margin: 0 0 25px 0;
}

.summary-card {
  background: white;
  border-radius: 20px;
  padding: 30px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
  position: sticky;
  top: 20px;
}

.summary-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 20px;
  border-bottom: 2px solid #edf2f7;
  margin-bottom: 20px;
}

.summary-header h3 {
  font-size: 1.3rem;
  font-weight: 700;
  color: #2d3748;
  margin: 0;
}

.summary-price {
  font-size: 2rem;
  font-weight: 900;
  color: inherit;
}

.summary-details {
  margin-bottom: 25px;
}

.summary-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 0;
  border-bottom: 1px solid #f7fafc;
}

.summary-label {
  font-size: 1rem;
  color: #718096;
  font-weight: 500;
}

.summary-value {
  font-size: 1rem;
  color: #2d3748;
  font-weight: 600;
}

.summary-images {
  margin-top: 25px;
  padding-top: 25px;
  border-top: 2px solid #edf2f7;
}

.summary-images h4 {
  font-size: 1.1rem;
  font-weight: 700;
  color: #2d3748;
  margin: 0 0 15px 0;
}

.summary-images-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 10px;
}

.summary-images-grid img {
  width: 100%;
  height: 80px;
  object-fit: cover;
  border-radius: 10px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.more-images {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 10px;
  font-weight: 700;
  font-size: 1.2rem;
  box-shadow: 0 2px 8px rgba(102, 126, 234, 0.3);
}

/* PhotoBook order summary */
.summary-photobook {
  margin-top: 25px;
  padding: 20px;
  background: linear-gradient(135deg, rgba(102, 126, 234, 0.1), rgba(118, 75, 162, 0.1));
  border-radius: 12px;
  border: 1px solid rgba(102, 126, 234, 0.3);
}

.summary-photobook h4 {
  margin: 0 0 12px 0;
  color: #667eea;
  font-size: 1.1rem;
}

.summary-photobook p {
  margin: 8px 0;
  color: #4a5568;
  font-size: 0.95rem;
  line-height: 1.5;
}

.summary-photobook .pdf-note {
  color: #718096;
  font-size: 0.85rem;
  font-style: italic;
}

.order-form-section {
  animation: fadeInRight 0.6s ease;
}

.order-form {
  background: white;
  border-radius: 20px;
  padding: 40px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
}

.form-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;
}

.form-group {
  margin-bottom: 25px;
}

.form-group label {
  display: block;
  font-size: 1rem;
  font-weight: 600;
  color: #2d3748;
  margin-bottom: 10px;
}

.form-group input {
  width: 100%;
  padding: 15px;
  border: 2px solid #e2e8f0;
  border-radius: 10px;
  font-size: 1rem;
  transition: all 0.3s ease;
  font-family: inherit;
  box-sizing: border-box;
}

.form-group input:focus {
  outline: none;
  border-color: transparent;
  box-shadow: 0 0 0 3px rgba(39, 38, 36, 0.1);
}

.form-group input.error {
  border-color: #f56565;
}

.error-message {
  display: block;
  color: #f56565;
  font-size: 0.85rem;
  margin-top: 5px;
  font-weight: 500;
}

/* Payment method selector */
.payment-method-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 14px;
  margin-top: 10px;
}

.payment-method-card {
  position: relative;
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 16px;
  border: 2px solid #e2e8f0;
  border-radius: 12px;
  cursor: pointer;
  background: #fff;
  transition: all 0.2s ease;
}

.payment-method-card:hover {
  border-color: #cbd5e0;
}

.payment-method-card.selected {
  border-color: rgba(0, 0, 0, 0.1);
  background: #e2e2e2;
  /* box-shadow: 0 0 0 3px rgba(0, 0, 0, 0.1); */
}

.payment-method-card input[type="radio"] {
  position: absolute;
  opacity: 0;
  width: 0;
  height: 0;
}

.payment-method-icon {
  font-size: 1.6rem;
  line-height: 1;
  flex-shrink: 0;
}

.payment-method-text {
  display: flex;
  flex-direction: column;
  gap: 3px;
  min-width: 0;
}

.payment-method-title {
  font-weight: 700;
  color: #2d3748;
  font-size: 0.98rem;
}

.payment-method-subtitle {
  font-size: 0.8rem;
  color: #718096;
  font-weight: 500;
}

.payment-brand-row {
  display: flex;
  gap: 6px;
  margin-top: 6px;
  flex-wrap: wrap;
}

.payment-brand-row svg {
  border-radius: 3px;
  box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.06);
}

.payment-method-check {
  position: absolute;
  top: 10px;
  right: 10px;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: rgb(45, 55, 72);
  color: white;
  font-size: 0.7rem;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  transform: scale(0.6);
  transition: all 0.2s ease;
}

.payment-method-card.selected .payment-method-check {
  opacity: 1;
  transform: scale(1);
}

.payment-security-note {
  font-size: 0.8rem;
  color: #718096;
  margin: 10px 2px 0 2px;
}

@media (max-width: 600px) {
  .payment-method-grid {
    grid-template-columns: 1fr;
  }
}

.submit-order-btn {
  width: 100%;
  background: rgb(45, 55, 72);
  color: white;
  border: none;
  padding: 18px;
  border-radius: 12px;
  font-size: 1.2rem;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.3s ease;
  /* box-shadow: 0 4px 15px rgba(72, 187, 120, 0.3); */
  margin-top: 10px;
}

.submit-order-btn:hover {
  transform: translateY(-3px);
  /* box-shadow: 0 6px 25px rgba(72, 187, 120, 0.4); */
}

.submit-order-btn:active {
  transform: translateY(-1px);
}

.form-note {
  text-align: center;
  color: #718096;
  font-size: 0.9rem;
  margin: 15px 0 0 0;
  line-height: 1.5;
}

@keyframes fadeInLeft {
  from {
    opacity: 0;
    transform: translateX(-30px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

@keyframes fadeInRight {
  from {
    opacity: 0;
    transform: translateX(30px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

/* Success Message */
.success-message-box {
  background: linear-gradient(135deg, #48bb78 0%, #38a169 100%);
  color: white;
  padding: 40px;
  border-radius: 20px;
  text-align: center;
  animation: scaleIn 0.5s ease;
  box-shadow: 0 10px 30px rgba(72, 187, 120, 0.3);
}

.success-icon {
  font-size: 4rem;
  margin-bottom: 20px;
  animation: bounce 1s infinite;
}

.success-message-box h3 {
  font-size: 1.8rem;
  margin: 0 0 15px 0;
  font-weight: bold;
}

.success-message-box p {
  font-size: 1.1rem;
  margin: 10px 0;
  opacity: 0.95;
}

.small-text {
  font-size: 0.95rem !important;
  opacity: 0.85 !important;
  margin-top: 20px !important;
}

.whatsapp-fallback-btn {
  display: inline-block;
  background: white;
  color: #25D366;
  padding: 15px 35px;
  border-radius: 12px;
  text-decoration: none;
  font-weight: bold;
  font-size: 1.1rem;
  margin: 20px 0 15px 0;
  transition: all 0.3s ease;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);
}

.whatsapp-fallback-btn:hover {
  transform: translateY(-3px);
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.3);
  background: #f0f0f0;
}

.back-home-btn {
  display: block;
  width: 100%;
  background: rgba(255, 255, 255, 0.2);
  color: white;
  border: 2px solid white;
  padding: 12px 25px;
  border-radius: 10px;
  cursor: pointer;
  font-weight: 600;
  font-size: 1rem;
  transition: all 0.3s ease;
  margin-top: 15px;
}

.back-home-btn:hover {
  background: white;
  color: #38a169;
}

.images-reminder {
  background: rgba(255, 255, 255, 0.2);
  border: 2px solid white;
  border-radius: 12px;
  padding: 15px 20px;
  margin: 20px 0;
}

.reminder-text {
  font-size: 1.05rem !important;
  font-weight: 600 !important;
  margin: 0 !important;
  opacity: 1 !important;
}

/* Image Links Section */
.image-links-section {
  background: rgba(255, 255, 255, 0.15);
  border: 2px solid white;
  border-radius: 12px;
  padding: 20px;
  margin: 20px 0;
  text-align: left;
}

.image-links-section h4 {
  margin: 0 0 15px 0;
  font-size: 1.1rem;
  font-weight: 700;
}

.links-list {
  max-height: 300px;
  overflow-y: auto;
  margin-bottom: 15px;
}

.link-item {
  background: rgba(255, 255, 255, 0.9);
  color: #2d3748;
  padding: 12px 15px;
  border-radius: 8px;
  margin-bottom: 10px;
  display: flex;
  align-items: center;
  gap: 10px;
  transition: all 0.2s ease;
}

.link-item:hover {
  background: white;
  transform: translateX(5px);
}

.link-number {
  font-weight: 700;
  color: inherit;
  min-width: 25px;
}

.image-link {
  flex: 1 1;
  color: #3182ce;
  text-decoration: none;
  font-weight: 600;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.image-link:hover {
  text-decoration: underline;
}

.copy-link-btn {
  background: none;
  color: white;
  border: none;
  padding: 6px 12px;
  border-radius: 6px;
  cursor: pointer;
  font-size: 1rem;
  transition: all 0.2s ease;
}

.copy-link-btn:hover {
  background: #e67e00;
  transform: scale(1.1);
}

.links-note {
  font-size: 0.95rem !important;
  font-weight: 600 !important;
  margin: 0 !important;
  opacity: 1 !important;
}

.submit-order-btn:disabled {
  opacity: 0.7;
  cursor: not-allowed;
  transform: none;
}

@keyframes scaleIn {
  from {
    opacity: 0;
    transform: scale(0.8);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}

@keyframes bounce {
  0%, 100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-10px);
  }
}

@media (max-width: 968px) {
  .order-content {
    grid-template-columns: 1fr;
  }

  .summary-card {
    position: static;
  }

  .form-row {
    grid-template-columns: 1fr;
  }

  .order-summary h2,
  .order-form-section h2 {
    font-size: 1.5rem;
  }

  .order-form {
    padding: 30px 20px;
  }

  .success-message-box {
    padding: 30px 20px;
  }

  .success-icon {
    font-size: 3rem;
  }

  .success-message-box h3 {
    font-size: 1.5rem;
  }
}

/* Manual Upload - Success Popup */
.manual-success-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.55);
  backdrop-filter: blur(6px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10001;
  padding: 20px;
  animation: fadeIn 0.3s ease;
}

.manual-success-modal {
  background: linear-gradient(135deg, #48bb78 0%, #38a169 100%);
  color: white;
  padding: 40px;
  border-radius: 20px;
  text-align: center;
  animation: scaleIn 0.4s ease;
  box-shadow: 0 20px 50px rgba(0, 0, 0, 0.4);
  max-width: 440px;
  width: 100%;
  max-height: 90vh;
  overflow-y: auto;
}

.manual-success-actions {
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-top: 16px;
}

@media (max-width: 480px) {
  .manual-success-modal {
    padding: 28px 20px;
  }
}

/* Upload Preloader Styles */
.upload-preloader-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(255, 255, 255, 0.72);
  backdrop-filter: blur(20px) saturate(180%);
  -webkit-backdrop-filter: blur(20px) saturate(180%);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10000;
  animation: fadeIn 0.3s ease;
}

.upload-preloader-content {
  text-align: center;
  padding: 40px;
  max-width: 380px;
  width: 90%;
}

.progress-ring-container {
  position: relative;
  width: 140px;
  height: 140px;
  margin: 0 auto 30px;
}

.progress-ring {
  width: 100%;
  height: 100%;
  transform: rotate(-90deg);
}

.progress-ring__track {
  fill: none;
  stroke: #e5e5ea;
  stroke-width: 6;
}

.progress-ring__bar {
  fill: none;
  stroke: #1d1d1f;
  stroke-width: 6;
  stroke-linecap: round;
  transition: stroke-dashoffset 0.3s ease;
}

.progress-ring__label {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.9rem;
  font-weight: 600;
  color: #1d1d1f;
  letter-spacing: -0.02em;
}

.upload-title {
  font-size: 1.8rem;
  font-weight: 800;
  color: #fff;
  margin: 20px 0 15px 0;
  text-shadow: 0 2px 10px rgba(0, 0, 0, 0.3);
}

.upload-message {
  font-size: 1.1rem;
  color: #2e2e2e;
  line-height: 1.6;
  margin: 15px 0;
  font-weight: 500;
}

.upload-message-title {
  font-size: 1.25rem;
  color: #1d1d1f;
  font-weight: 600;
  margin: 0 0 8px;
}

.upload-message-warning {
  font-size: 1.05rem;
  color: #6e6e73;
  line-height: 1.5;
  margin: 0;
  font-weight: 500;
}

.upload-message strong {
  color: #2e2e2e;
  font-weight: 700;
  display: inline-block;
  animation: blink 2s ease-in-out infinite;
}

.upload-info {
  margin-top: 25px;
  padding: 15px 20px;
  background: rgba(255, 0, 179, 0.15);
  border-radius: 15px;
  border: 2px solid rgba(255, 0, 179, 0.15);
}

.upload-info p {
  margin: 0;
  font-size: 1rem;
  color: #2e2e2e;
  font-weight: 600;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

@keyframes blink {
  0%, 100% {
    opacity: 1;
  }
  50% {
    opacity: 0.7;
  }
}

/* Responsive styles for preloader */
@media (max-width: 768px) {
  .upload-preloader-content {
    padding: 20px;
  }

  .progress-ring-container {
    width: 120px;
    height: 120px;
    margin-bottom: 24px;
  }

  .progress-ring__label {
    font-size: 1.6rem;
  }

  .upload-title {
    font-size: 1.4rem;
  }

  .upload-message {
    font-size: 1rem;
  }

  .upload-message-title {
    font-size: 1.1rem;
  }

  .upload-message-warning {
    font-size: 0.95rem;
  }

  .upload-info p {
    font-size: 0.95rem;
  }
}

@media (max-width: 480px) {
  .progress-ring-container {
    width: 104px;
    height: 104px;
    margin-bottom: 20px;
  }

  .progress-ring__label {
    font-size: 1.4rem;
  }

  .upload-title {
    font-size: 1.2rem;
    margin: 15px 0 10px 0;
  }

  .upload-message {
    font-size: 0.95rem;
    line-height: 1.5;
  }

  .upload-message-title {
    font-size: 1rem;
  }

  .upload-message-warning {
    font-size: 0.9rem;
    line-height: 1.5;
  }

  .upload-info {
    padding: 12px 15px;
    margin-top: 20px;
  }

  .upload-info p {
    font-size: 0.9rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/OrderForm.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,wDAAwD;AAC1D;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;;EAEE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,yCAAyC;EACzC,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,oBAAoB;EACpB,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,wCAAwC;AAC1C;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,8CAA8C;AAChD;;AAEA,4BAA4B;AAC5B;EACE,gBAAgB;EAChB,aAAa;EACb,sFAAsF;EACtF,mBAAmB;EACnB,0CAA0C;AAC5C;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,yBAAyB;EACzB,oBAAoB;EACpB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,2CAA2C;AAC7C;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA,4BAA4B;AAC5B;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,gCAAgC;EAChC,mBAAmB;EACnB,8CAA8C;AAChD;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,yCAAyC;AAC3C;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,2BAA2B;EAC3B,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;EACV,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE,WAAW;EACX,2BAA2B;EAC3B,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,oDAAoD;EACpD,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,oDAAoD;AACtD;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA,oBAAoB;AACpB;EACE,6DAA6D;EAC7D,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,4BAA4B;EAC5B,+CAA+C;AACjD;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,aAAa;AACf;;AAEA;EACE,6BAA6B;EAC7B,wBAAwB;EACxB,2BAA2B;AAC7B;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,qBAAqB;EACrB,iBAAiB;EACjB,iBAAiB;EACjB,qBAAqB;EACrB,yBAAyB;EACzB,yCAAyC;AAC3C;;AAEA;EACE,2BAA2B;EAC3B,yCAAyC;EACzC,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,oCAAoC;EACpC,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,6BAA6B;EAC7B,2BAA2B;EAC3B,oBAAoB;EACpB,qBAAqB;AACvB;;AAEA,wBAAwB;AACxB;EACE,qCAAqC;EACrC,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,oCAAoC;EACpC,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,cAAc;EACd,qBAAqB;EACrB,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,6BAA6B;EAC7B,2BAA2B;EAC3B,oBAAoB;EACpB,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE;IACE,UAAU;IACV,qBAAqB;EACvB;EACA;IACE,UAAU;IACV,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,wBAAwB;EAC1B;EACA;IACE,4BAA4B;EAC9B;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;;IAEE,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA,kCAAkC;AAClC;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,+BAA+B;EAC/B,0BAA0B;EAC1B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,aAAa;EACb,2BAA2B;AAC7B;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,4BAA4B;EAC5B,0CAA0C;EAC1C,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE;IACE,kBAAkB;EACpB;AACF;;AAEA,4BAA4B;AAC5B;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,qCAAqC;EACrC,0CAA0C;EAC1C,kDAAkD;EAClD,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,UAAU;EACV,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,eAAe;EACf,eAAe;EACf,qBAAqB;EACrB,uCAAuC;AACzC;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;EACX,qBAAqB;EACrB,0CAA0C;AAC5C;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,qBAAqB;EACrB,wCAAwC;AAC1C;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,mCAAmC;EACnC,mBAAmB;EACnB,yCAAyC;AAC3C;;AAEA;EACE,SAAS;EACT,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,YAAY;EACd;AACF;;AAEA,oCAAoC;AACpC;EACE;IACE,aAAa;EACf;;EAEA;IACE,YAAY;IACZ,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,YAAY;IACZ,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;IACjB,qBAAqB;EACvB;;EAEA;IACE,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;EACnB;AACF","sourcesContent":[".posta{\n  color: lightcoral;\n}\n\n.order-form-page {\n  min-height: 100vh;\n  background: linear-gradient(to bottom, #f7fafc, #edf2f7);\n}\n\n.order-container {\n  max-width: 1200px;\n  margin: 0 auto;\n}\n\n.order-content {\n  display: grid;\n  grid-template-columns: 1fr 1.5fr;\n  gap: 30px;\n  margin-top: 30px;\n}\n\n.order-summary {\n  animation: fadeInLeft 0.6s ease;\n}\n\n.order-summary h2,\n.order-form-section h2 {\n  font-size: 1.8rem;\n  font-weight: 800;\n  color: #2d3748;\n  margin: 0 0 25px 0;\n}\n\n.summary-card {\n  background: white;\n  border-radius: 20px;\n  padding: 30px;\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);\n  position: sticky;\n  top: 20px;\n}\n\n.summary-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding-bottom: 20px;\n  border-bottom: 2px solid #edf2f7;\n  margin-bottom: 20px;\n}\n\n.summary-header h3 {\n  font-size: 1.3rem;\n  font-weight: 700;\n  color: #2d3748;\n  margin: 0;\n}\n\n.summary-price {\n  font-size: 2rem;\n  font-weight: 900;\n  color: inherit;\n}\n\n.summary-details {\n  margin-bottom: 25px;\n}\n\n.summary-item {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 12px 0;\n  border-bottom: 1px solid #f7fafc;\n}\n\n.summary-label {\n  font-size: 1rem;\n  color: #718096;\n  font-weight: 500;\n}\n\n.summary-value {\n  font-size: 1rem;\n  color: #2d3748;\n  font-weight: 600;\n}\n\n.summary-images {\n  margin-top: 25px;\n  padding-top: 25px;\n  border-top: 2px solid #edf2f7;\n}\n\n.summary-images h4 {\n  font-size: 1.1rem;\n  font-weight: 700;\n  color: #2d3748;\n  margin: 0 0 15px 0;\n}\n\n.summary-images-grid {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: 10px;\n}\n\n.summary-images-grid img {\n  width: 100%;\n  height: 80px;\n  object-fit: cover;\n  border-radius: 10px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n}\n\n.more-images {\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  color: white;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 10px;\n  font-weight: 700;\n  font-size: 1.2rem;\n  box-shadow: 0 2px 8px rgba(102, 126, 234, 0.3);\n}\n\n/* PhotoBook order summary */\n.summary-photobook {\n  margin-top: 25px;\n  padding: 20px;\n  background: linear-gradient(135deg, rgba(102, 126, 234, 0.1), rgba(118, 75, 162, 0.1));\n  border-radius: 12px;\n  border: 1px solid rgba(102, 126, 234, 0.3);\n}\n\n.summary-photobook h4 {\n  margin: 0 0 12px 0;\n  color: #667eea;\n  font-size: 1.1rem;\n}\n\n.summary-photobook p {\n  margin: 8px 0;\n  color: #4a5568;\n  font-size: 0.95rem;\n  line-height: 1.5;\n}\n\n.summary-photobook .pdf-note {\n  color: #718096;\n  font-size: 0.85rem;\n  font-style: italic;\n}\n\n.order-form-section {\n  animation: fadeInRight 0.6s ease;\n}\n\n.order-form {\n  background: white;\n  border-radius: 20px;\n  padding: 40px;\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);\n}\n\n.form-row {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 20px;\n}\n\n.form-group {\n  margin-bottom: 25px;\n}\n\n.form-group label {\n  display: block;\n  font-size: 1rem;\n  font-weight: 600;\n  color: #2d3748;\n  margin-bottom: 10px;\n}\n\n.form-group input {\n  width: 100%;\n  padding: 15px;\n  border: 2px solid #e2e8f0;\n  border-radius: 10px;\n  font-size: 1rem;\n  transition: all 0.3s ease;\n  font-family: inherit;\n  box-sizing: border-box;\n}\n\n.form-group input:focus {\n  outline: none;\n  border-color: transparent;\n  box-shadow: 0 0 0 3px rgba(39, 38, 36, 0.1);\n}\n\n.form-group input.error {\n  border-color: #f56565;\n}\n\n.error-message {\n  display: block;\n  color: #f56565;\n  font-size: 0.85rem;\n  margin-top: 5px;\n  font-weight: 500;\n}\n\n/* Payment method selector */\n.payment-method-grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 14px;\n  margin-top: 10px;\n}\n\n.payment-method-card {\n  position: relative;\n  display: flex;\n  align-items: flex-start;\n  gap: 12px;\n  padding: 16px;\n  border: 2px solid #e2e8f0;\n  border-radius: 12px;\n  cursor: pointer;\n  background: #fff;\n  transition: all 0.2s ease;\n}\n\n.payment-method-card:hover {\n  border-color: #cbd5e0;\n}\n\n.payment-method-card.selected {\n  border-color: rgba(0, 0, 0, 0.1);\n  background: #e2e2e2;\n  /* box-shadow: 0 0 0 3px rgba(0, 0, 0, 0.1); */\n}\n\n.payment-method-card input[type=\"radio\"] {\n  position: absolute;\n  opacity: 0;\n  width: 0;\n  height: 0;\n}\n\n.payment-method-icon {\n  font-size: 1.6rem;\n  line-height: 1;\n  flex-shrink: 0;\n}\n\n.payment-method-text {\n  display: flex;\n  flex-direction: column;\n  gap: 3px;\n  min-width: 0;\n}\n\n.payment-method-title {\n  font-weight: 700;\n  color: #2d3748;\n  font-size: 0.98rem;\n}\n\n.payment-method-subtitle {\n  font-size: 0.8rem;\n  color: #718096;\n  font-weight: 500;\n}\n\n.payment-brand-row {\n  display: flex;\n  gap: 6px;\n  margin-top: 6px;\n  flex-wrap: wrap;\n}\n\n.payment-brand-row svg {\n  border-radius: 3px;\n  box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.06);\n}\n\n.payment-method-check {\n  position: absolute;\n  top: 10px;\n  right: 10px;\n  width: 20px;\n  height: 20px;\n  border-radius: 50%;\n  background: rgb(45, 55, 72);\n  color: white;\n  font-size: 0.7rem;\n  font-weight: 700;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  opacity: 0;\n  transform: scale(0.6);\n  transition: all 0.2s ease;\n}\n\n.payment-method-card.selected .payment-method-check {\n  opacity: 1;\n  transform: scale(1);\n}\n\n.payment-security-note {\n  font-size: 0.8rem;\n  color: #718096;\n  margin: 10px 2px 0 2px;\n}\n\n@media (max-width: 600px) {\n  .payment-method-grid {\n    grid-template-columns: 1fr;\n  }\n}\n\n.submit-order-btn {\n  width: 100%;\n  background: rgb(45, 55, 72);\n  color: white;\n  border: none;\n  padding: 18px;\n  border-radius: 12px;\n  font-size: 1.2rem;\n  font-weight: 700;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  /* box-shadow: 0 4px 15px rgba(72, 187, 120, 0.3); */\n  margin-top: 10px;\n}\n\n.submit-order-btn:hover {\n  transform: translateY(-3px);\n  /* box-shadow: 0 6px 25px rgba(72, 187, 120, 0.4); */\n}\n\n.submit-order-btn:active {\n  transform: translateY(-1px);\n}\n\n.form-note {\n  text-align: center;\n  color: #718096;\n  font-size: 0.9rem;\n  margin: 15px 0 0 0;\n  line-height: 1.5;\n}\n\n@keyframes fadeInLeft {\n  from {\n    opacity: 0;\n    transform: translateX(-30px);\n  }\n  to {\n    opacity: 1;\n    transform: translateX(0);\n  }\n}\n\n@keyframes fadeInRight {\n  from {\n    opacity: 0;\n    transform: translateX(30px);\n  }\n  to {\n    opacity: 1;\n    transform: translateX(0);\n  }\n}\n\n/* Success Message */\n.success-message-box {\n  background: linear-gradient(135deg, #48bb78 0%, #38a169 100%);\n  color: white;\n  padding: 40px;\n  border-radius: 20px;\n  text-align: center;\n  animation: scaleIn 0.5s ease;\n  box-shadow: 0 10px 30px rgba(72, 187, 120, 0.3);\n}\n\n.success-icon {\n  font-size: 4rem;\n  margin-bottom: 20px;\n  animation: bounce 1s infinite;\n}\n\n.success-message-box h3 {\n  font-size: 1.8rem;\n  margin: 0 0 15px 0;\n  font-weight: bold;\n}\n\n.success-message-box p {\n  font-size: 1.1rem;\n  margin: 10px 0;\n  opacity: 0.95;\n}\n\n.small-text {\n  font-size: 0.95rem !important;\n  opacity: 0.85 !important;\n  margin-top: 20px !important;\n}\n\n.whatsapp-fallback-btn {\n  display: inline-block;\n  background: white;\n  color: #25D366;\n  padding: 15px 35px;\n  border-radius: 12px;\n  text-decoration: none;\n  font-weight: bold;\n  font-size: 1.1rem;\n  margin: 20px 0 15px 0;\n  transition: all 0.3s ease;\n  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);\n}\n\n.whatsapp-fallback-btn:hover {\n  transform: translateY(-3px);\n  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.3);\n  background: #f0f0f0;\n}\n\n.back-home-btn {\n  display: block;\n  width: 100%;\n  background: rgba(255, 255, 255, 0.2);\n  color: white;\n  border: 2px solid white;\n  padding: 12px 25px;\n  border-radius: 10px;\n  cursor: pointer;\n  font-weight: 600;\n  font-size: 1rem;\n  transition: all 0.3s ease;\n  margin-top: 15px;\n}\n\n.back-home-btn:hover {\n  background: white;\n  color: #38a169;\n}\n\n.images-reminder {\n  background: rgba(255, 255, 255, 0.2);\n  border: 2px solid white;\n  border-radius: 12px;\n  padding: 15px 20px;\n  margin: 20px 0;\n}\n\n.reminder-text {\n  font-size: 1.05rem !important;\n  font-weight: 600 !important;\n  margin: 0 !important;\n  opacity: 1 !important;\n}\n\n/* Image Links Section */\n.image-links-section {\n  background: rgba(255, 255, 255, 0.15);\n  border: 2px solid white;\n  border-radius: 12px;\n  padding: 20px;\n  margin: 20px 0;\n  text-align: left;\n}\n\n.image-links-section h4 {\n  margin: 0 0 15px 0;\n  font-size: 1.1rem;\n  font-weight: 700;\n}\n\n.links-list {\n  max-height: 300px;\n  overflow-y: auto;\n  margin-bottom: 15px;\n}\n\n.link-item {\n  background: rgba(255, 255, 255, 0.9);\n  color: #2d3748;\n  padding: 12px 15px;\n  border-radius: 8px;\n  margin-bottom: 10px;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  transition: all 0.2s ease;\n}\n\n.link-item:hover {\n  background: white;\n  transform: translateX(5px);\n}\n\n.link-number {\n  font-weight: 700;\n  color: inherit;\n  min-width: 25px;\n}\n\n.image-link {\n  flex: 1;\n  color: #3182ce;\n  text-decoration: none;\n  font-weight: 600;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.image-link:hover {\n  text-decoration: underline;\n}\n\n.copy-link-btn {\n  background: none;\n  color: white;\n  border: none;\n  padding: 6px 12px;\n  border-radius: 6px;\n  cursor: pointer;\n  font-size: 1rem;\n  transition: all 0.2s ease;\n}\n\n.copy-link-btn:hover {\n  background: #e67e00;\n  transform: scale(1.1);\n}\n\n.links-note {\n  font-size: 0.95rem !important;\n  font-weight: 600 !important;\n  margin: 0 !important;\n  opacity: 1 !important;\n}\n\n.submit-order-btn:disabled {\n  opacity: 0.7;\n  cursor: not-allowed;\n  transform: none;\n}\n\n@keyframes scaleIn {\n  from {\n    opacity: 0;\n    transform: scale(0.8);\n  }\n  to {\n    opacity: 1;\n    transform: scale(1);\n  }\n}\n\n@keyframes bounce {\n  0%, 100% {\n    transform: translateY(0);\n  }\n  50% {\n    transform: translateY(-10px);\n  }\n}\n\n@media (max-width: 968px) {\n  .order-content {\n    grid-template-columns: 1fr;\n  }\n\n  .summary-card {\n    position: static;\n  }\n\n  .form-row {\n    grid-template-columns: 1fr;\n  }\n\n  .order-summary h2,\n  .order-form-section h2 {\n    font-size: 1.5rem;\n  }\n\n  .order-form {\n    padding: 30px 20px;\n  }\n\n  .success-message-box {\n    padding: 30px 20px;\n  }\n\n  .success-icon {\n    font-size: 3rem;\n  }\n\n  .success-message-box h3 {\n    font-size: 1.5rem;\n  }\n}\n\n/* Manual Upload - Success Popup */\n.manual-success-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.55);\n  backdrop-filter: blur(6px);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 10001;\n  padding: 20px;\n  animation: fadeIn 0.3s ease;\n}\n\n.manual-success-modal {\n  background: linear-gradient(135deg, #48bb78 0%, #38a169 100%);\n  color: white;\n  padding: 40px;\n  border-radius: 20px;\n  text-align: center;\n  animation: scaleIn 0.4s ease;\n  box-shadow: 0 20px 50px rgba(0, 0, 0, 0.4);\n  max-width: 440px;\n  width: 100%;\n  max-height: 90vh;\n  overflow-y: auto;\n}\n\n.manual-success-actions {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  margin-top: 16px;\n}\n\n@media (max-width: 480px) {\n  .manual-success-modal {\n    padding: 28px 20px;\n  }\n}\n\n/* Upload Preloader Styles */\n.upload-preloader-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(255, 255, 255, 0.72);\n  backdrop-filter: blur(20px) saturate(180%);\n  -webkit-backdrop-filter: blur(20px) saturate(180%);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 10000;\n  animation: fadeIn 0.3s ease;\n}\n\n.upload-preloader-content {\n  text-align: center;\n  padding: 40px;\n  max-width: 380px;\n  width: 90%;\n}\n\n.progress-ring-container {\n  position: relative;\n  width: 140px;\n  height: 140px;\n  margin: 0 auto 30px;\n}\n\n.progress-ring {\n  width: 100%;\n  height: 100%;\n  transform: rotate(-90deg);\n}\n\n.progress-ring__track {\n  fill: none;\n  stroke: #e5e5ea;\n  stroke-width: 6;\n}\n\n.progress-ring__bar {\n  fill: none;\n  stroke: #1d1d1f;\n  stroke-width: 6;\n  stroke-linecap: round;\n  transition: stroke-dashoffset 0.3s ease;\n}\n\n.progress-ring__label {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 1.9rem;\n  font-weight: 600;\n  color: #1d1d1f;\n  letter-spacing: -0.02em;\n}\n\n.upload-title {\n  font-size: 1.8rem;\n  font-weight: 800;\n  color: #fff;\n  margin: 20px 0 15px 0;\n  text-shadow: 0 2px 10px rgba(0, 0, 0, 0.3);\n}\n\n.upload-message {\n  font-size: 1.1rem;\n  color: #2e2e2e;\n  line-height: 1.6;\n  margin: 15px 0;\n  font-weight: 500;\n}\n\n.upload-message-title {\n  font-size: 1.25rem;\n  color: #1d1d1f;\n  font-weight: 600;\n  margin: 0 0 8px;\n}\n\n.upload-message-warning {\n  font-size: 1.05rem;\n  color: #6e6e73;\n  line-height: 1.5;\n  margin: 0;\n  font-weight: 500;\n}\n\n.upload-message strong {\n  color: #2e2e2e;\n  font-weight: 700;\n  display: inline-block;\n  animation: blink 2s ease-in-out infinite;\n}\n\n.upload-info {\n  margin-top: 25px;\n  padding: 15px 20px;\n  background: rgba(255, 0, 179, 0.15);\n  border-radius: 15px;\n  border: 2px solid rgba(255, 0, 179, 0.15);\n}\n\n.upload-info p {\n  margin: 0;\n  font-size: 1rem;\n  color: #2e2e2e;\n  font-weight: 600;\n}\n\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n\n@keyframes spin {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n@keyframes blink {\n  0%, 100% {\n    opacity: 1;\n  }\n  50% {\n    opacity: 0.7;\n  }\n}\n\n/* Responsive styles for preloader */\n@media (max-width: 768px) {\n  .upload-preloader-content {\n    padding: 20px;\n  }\n\n  .progress-ring-container {\n    width: 120px;\n    height: 120px;\n    margin-bottom: 24px;\n  }\n\n  .progress-ring__label {\n    font-size: 1.6rem;\n  }\n\n  .upload-title {\n    font-size: 1.4rem;\n  }\n\n  .upload-message {\n    font-size: 1rem;\n  }\n\n  .upload-message-title {\n    font-size: 1.1rem;\n  }\n\n  .upload-message-warning {\n    font-size: 0.95rem;\n  }\n\n  .upload-info p {\n    font-size: 0.95rem;\n  }\n}\n\n@media (max-width: 480px) {\n  .progress-ring-container {\n    width: 104px;\n    height: 104px;\n    margin-bottom: 20px;\n  }\n\n  .progress-ring__label {\n    font-size: 1.4rem;\n  }\n\n  .upload-title {\n    font-size: 1.2rem;\n    margin: 15px 0 10px 0;\n  }\n\n  .upload-message {\n    font-size: 0.95rem;\n    line-height: 1.5;\n  }\n\n  .upload-message-title {\n    font-size: 1rem;\n  }\n\n  .upload-message-warning {\n    font-size: 0.9rem;\n    line-height: 1.5;\n  }\n\n  .upload-info {\n    padding: 12px 15px;\n    margin-top: 20px;\n  }\n\n  .upload-info p {\n    font-size: 0.9rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
